module.exports = __webpack_public_path__ + "img/header_01.81c174ba.png";